"use client";

import Image from "next/image";
import React, { useState } from "react";
import { twMerge } from "tailwind-merge";

import { BREAKPOINTS } from "@/globals";
import { TYPO_STYLES } from "@/styles/typography";
import { WRAPPER_STYLES } from "@/styles/wrapper";

export type VideoModuleProps = {
    disclamer: string;
    previewSrc: string | undefined;
    videoId: string;
};
export const VideoModuleView = ({ videoId, previewSrc, disclamer }: VideoModuleProps) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const previewImage = previewSrc || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    return (
        <div className={twMerge(WRAPPER_STYLES.VCenterStretch(), "gap-6")}>
            <div className="relative aspect-video w-full cursor-pointer overflow-hidden bg-black">
                {isPlaying ? (
                    <iframe
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        className="absolute inset-0 h-full w-full"
                    />
                ) : (
                    <button
                        onClick={() => setIsPlaying(true)}
                        className="absolute inset-0 h-full w-full"
                    >
                        <Image
                            src={previewImage}
                            width="1600"
                            height="900"
                            alt="YouTube video preview"
                            className="absolute inset-0 h-full w-full object-cover"
                            sizes={`(min-width: ${BREAKPOINTS.md}px) ${BREAKPOINTS.lg}px, (min-width: ${BREAKPOINTS.lg}px) ${BREAKPOINTS.xl}px, 100vw`}
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                            <div className="text-white text-5xl">▶</div>
                        </div>
                    </button>
                )}
            </div>
            <p className={TYPO_STYLES.bodyNormal14()}>{disclamer}</p>
        </div>
    );
};
